/*
################
## AccountUse ##
################

Input group for account uses.

* OPTIONS
    * profileModel[String]: Model of data. Required.
    * accountTypes[Array]: Types of accounts to render. This can be: personal, selfemployed and / or inversion. At least one required.
    * hasPEP [String]: Show (or not) the incomes fields. This depends if the user has a PEP. Not required.

* EXAMPLE
    <AccountUse
        profileModel="userProfile.selfEmployed_accountUse"
        accountTypes={['personal', 'professional', 'other']}
        {...this.props}
    />

*/

import { BANK_AND_TRAVEL_CHECKS_MOVEMENTS, CRYPTO_CURRENCY_MOVEMENTS } from 'constants/fioc';
import { NEW_OPTIONS_OPERATIONS } from 'constants/featureFlagging';

const React = require('react');
const Incomes = require('components/incomes/incomes');
const { connect } = require('react-redux');
import { RadioButton } from 'components/RadioButton/RadioButton';
const CheckBox = require('components/checkBox/checkBox');
import { formatText } from 'core/i18n';
import { getIncomesData } from 'constants/fioc';

class accountUse extends React.Component {
    constructor(props) {
        super(props);

        this.buildOperationsSection = this.buildOperationsSection.bind(this);
        this.handleDataToSave = this.handleDataToSave.bind(this);
        this.generatedOperationsData = this.generatedOperationsData.bind(this);
        this.generatedOperations = this.generatedOperations.bind(this);
    }

    generatedOperationsData() {
        const handleDataToSave = this.handleDataToSave;
        const { flags } = this.props;
        const areNewOptionsEnable = flags.get(NEW_OPTIONS_OPERATIONS);

        return [
            {
                label: formatText('field-PEP_item_0'),
                model: 'userProfile.highOperativeWithRiskCountries',
                onChange(value) {
                    handleDataToSave('highOperativeWithRiskCountries', value);
                },
            },
            {
                label: formatText(`field-PEP_item_${areNewOptionsEnable ? '8' : '1'}`),
                model: `userProfile.${
                    areNewOptionsEnable ? BANK_AND_TRAVEL_CHECKS_MOVEMENTS : 'buyingSellingBearerPaymentMethods'
                }`,
                onChange(value) {
                    handleDataToSave(
                        areNewOptionsEnable ? BANK_AND_TRAVEL_CHECKS_MOVEMENTS : 'buyingSellingBearerPaymentMethods',
                        value
                    );
                },
            },
            {
                label: formatText(`field-PEP_item_${areNewOptionsEnable ? '9' : '2'}`),
                model: `userProfile.${
                    areNewOptionsEnable ? CRYPTO_CURRENCY_MOVEMENTS : 'frequentTravelChecksMovements'
                }`,
                onChange(value) {
                    handleDataToSave(
                        areNewOptionsEnable ? CRYPTO_CURRENCY_MOVEMENTS : 'frequentTravelChecksMovements',
                        value
                    );
                },
            },
            {
                label: formatText('field-PEP_item_3'),
                model: 'userProfile.deliveryOrCashWithdrawals',
                onChange(value) {
                    handleDataToSave('deliveryOrCashWithdrawals', value);
                },
            },
            {
                label: formatText('field-PEP_item_4'),
                model: 'userProfile.buyingAndSellingForeingBanknotes',
                onChange(value) {
                    handleDataToSave('buyingAndSellingForeingBanknotes', value);
                },
            },
            {
                label: formatText('field-PEP_item_5'),
                model: 'userProfile.paymentOrdersOrCollectionAbroad',
                onChange(value) {
                    handleDataToSave('paymentOrdersOrCollectionAbroad', value);
                },
            },
            {
                label: formatText('field-PEP_item_6'),
                model: 'userProfile.foreingTradeOperations',
                onChange(value) {
                    handleDataToSave('foreingTradeOperations', value);
                },
            },
            {
                label: formatText('field-PEP_item_7'),
                model: 'userProfile.noneOfTheAbove',
                onChange(value) {
                    handleDataToSave('noneOfTheAbove', value);
                },
            },
        ];
    }

    generatedOperations(used = true) {
        const { userProfile, formActions, flags } = this.props;
        const areNewOptionsEnable = flags.get(NEW_OPTIONS_OPERATIONS);
        let operations;

        if (used) {
            const oldOperations = {
                buyingSellingBearerPaymentMethods:
                    typeof userProfile['buyingSellingBearerPaymentMethods'] !== 'undefined'
                        ? userProfile['buyingSellingBearerPaymentMethods']
                        : false,
                frequentTravelChecksMovements:
                    typeof userProfile['frequentTravelChecksMovements'] !== 'undefined'
                        ? userProfile['frequentTravelChecksMovements']
                        : false,
            };

            const newOperations = {
                [BANK_AND_TRAVEL_CHECKS_MOVEMENTS]:
                    typeof userProfile[BANK_AND_TRAVEL_CHECKS_MOVEMENTS] !== 'undefined'
                        ? userProfile[BANK_AND_TRAVEL_CHECKS_MOVEMENTS]
                        : false,
                [CRYPTO_CURRENCY_MOVEMENTS]:
                    typeof userProfile[CRYPTO_CURRENCY_MOVEMENTS] !== 'undefined'
                        ? userProfile[CRYPTO_CURRENCY_MOVEMENTS]
                        : false,
            };

            operations = {
                highOperativeWithRiskCountries:
                    typeof userProfile['highOperativeWithRiskCountries'] !== 'undefined'
                        ? userProfile['highOperativeWithRiskCountries']
                        : false,
                deliveryOrCashWithdrawals:
                    typeof userProfile['deliveryOrCashWithdrawals'] !== 'undefined'
                        ? userProfile['deliveryOrCashWithdrawals']
                        : false,
                buyingAndSellingForeingBanknotes:
                    typeof userProfile['buyingAndSellingForeingBanknotes'] !== 'undefined'
                        ? userProfile['buyingAndSellingForeingBanknotes']
                        : false,
                paymentOrdersOrCollectionAbroad:
                    typeof userProfile['paymentOrdersOrCollectionAbroad'] !== 'undefined'
                        ? userProfile['paymentOrdersOrCollectionAbroad']
                        : false,
                foreingTradeOperations:
                    typeof userProfile['foreingTradeOperations'] !== 'undefined'
                        ? userProfile['foreingTradeOperations']
                        : false,
                noneOfTheAbove:
                    typeof userProfile['noneOfTheAbove'] !== 'undefined' ? userProfile['noneOfTheAbove'] : false,
                ...(areNewOptionsEnable ? newOperations : oldOperations),
            };
        } else {
            const oldOperations = {
                buyingSellingBearerPaymentMethods: false,
                frequentTravelChecksMovements: false,
            };

            const newOperations = {
                [BANK_AND_TRAVEL_CHECKS_MOVEMENTS]: false,
                [CRYPTO_CURRENCY_MOVEMENTS]: false,
            };

            operations = {
                highOperativeWithRiskCountries: false,
                deliveryOrCashWithdrawals: false,
                buyingAndSellingForeingBanknotes: false,
                paymentOrdersOrCollectionAbroad: false,
                foreingTradeOperations: false,
                noneOfTheAbove: false,
                ...(areNewOptionsEnable ? newOperations : oldOperations),
            };

            formActions.change('userProfile.highOperativeWithRiskCountries', false);
            formActions.change('userProfile.buyingSellingBearerPaymentMethods', false);
            formActions.change('userProfile.frequentTravelChecksMovements', false);
            formActions.change('userProfile.deliveryOrCashWithdrawals', false);
            formActions.change('userProfile.buyingAndSellingForeingBanknotes', false);
            formActions.change('userProfile.paymentOrdersOrCollectionAbroad', false);
            formActions.change('userProfile.foreingTradeOperations', false);
            formActions.change('userProfile.noneOfTheAbove', false);
            formActions.change(`userProfile.${BANK_AND_TRAVEL_CHECKS_MOVEMENTS}`, false);
            formActions.change(`userProfile.${CRYPTO_CURRENCY_MOVEMENTS}`, false);
        }

        return operations;
    }

    handleDataToSave(name, value) {
        const { handleSave, formActions, flags } = this.props;
        const areNewOptionsEnable = flags.get(NEW_OPTIONS_OPERATIONS);

        const operations = this.generatedOperations();
        const addExtraFields = () => {
            if (areNewOptionsEnable) {
                operations[BANK_AND_TRAVEL_CHECKS_MOVEMENTS] = false;
                operations[CRYPTO_CURRENCY_MOVEMENTS] = false;

                return;
            }

            operations.highOperativeWithRiskCountries = false;
            operations.buyingSellingBearerPaymentMethods = false;
        };

        if (name === 'noneOfTheAbove') {
            formActions.change('userProfile.highOperativeWithRiskCountries', false);
            formActions.change('userProfile.buyingSellingBearerPaymentMethods', false);
            formActions.change(`userProfile.${BANK_AND_TRAVEL_CHECKS_MOVEMENTS}`, false);
            formActions.change(`userProfile.${CRYPTO_CURRENCY_MOVEMENTS}`, false);
            formActions.change('userProfile.frequentTravelChecksMovements', false);
            formActions.change('userProfile.deliveryOrCashWithdrawals', false);
            formActions.change('userProfile.buyingAndSellingForeingBanknotes', false);
            formActions.change('userProfile.paymentOrdersOrCollectionAbroad', false);
            formActions.change('userProfile.foreingTradeOperations', false);
            operations.frequentTravelChecksMovements = false;
            operations.deliveryOrCashWithdrawals = false;
            operations.buyingAndSellingForeingBanknotes = false;
            operations.paymentOrdersOrCollectionAbroad = false;
            operations.foreingTradeOperations = false;
            addExtraFields();
        } else {
            formActions.change('userProfile.noneOfTheAbove', false);
            operations.noneOfTheAbove = false;
        }
        operations[name] = value;
        handleSave('operations', operations);
    }

    buildOperationsSection(model) {
        const { userProfile, userProfileForm, formActions, disabled } = this.props;
        const operationsData = this.generatedOperationsData();

        return (
            <div style={{ clear: 'both' }} className="fioc-account-type__account-use__operations">
                <label>{formatText('field-operations')}</label>
                <label className="sub-label">{formatText('field-checkMoreThanOne')}</label>
                <CheckBox
                    profileModel={model}
                    fieldsRequired="1"
                    checkBoxList={operationsData}
                    userProfile={userProfile}
                    userProfileForm={userProfileForm}
                    formActions={formActions}
                    disabled={disabled}
                    focusAnimated
                    checkBoxListErrorMessage={formatText('validation-fieldRequired')}
                />
            </div>
        );
    }

    buildIncomes() {
        const { handleSave } = this.props;
        return <Incomes {...this.props} handleSave={handleSave} />;
    }

    getOptionList(accountTypes) {
        const optionsList = [];
        if (accountTypes !== null) {
            for (let i = 0; i < accountTypes.length; i++) {
                switch (accountTypes[i]) {
                    case 'personal':
                        optionsList[i] = { label: formatText('field-personal'), value: 'personal' };
                        break;
                    case 'professional':
                        optionsList[i] = { label: formatText('field-professional'), value: 'professional' };
                        break;
                    case 'other':
                        optionsList[i] = { label: formatText('field-otherOperative'), value: 'other' };
                        break;
                    default:
                        break;
                }
            }
        }

        return optionsList;
    }

    render() {
        const { userProfile, profileModel, accountTypes, hasPEP, formActions, resetIncomes } = this.props;
        const generatedOperations = this.generatedOperations;
        const handleSave = this.props.handleSave;
        const model = profileModel.split('.');
        const optionsList = this.getOptionList(accountTypes);
        const noHasPEP = hasPEP === 'false' || typeof hasPEP === 'undefined';
        const isOther = userProfile[model[1]] === 'other';
        const isProfessional = userProfile[model[1]] === 'professional' && userProfile.accountType === '01';
        let viewOperation, viewIncomes;

        if (typeof userProfile[model[1]] !== 'undefined' && userProfile[model[1]] !== 'personal') {
            viewOperation = this.buildOperationsSection(`${profileModel}_list`);
            if (noHasPEP && (isOther || isProfessional)) {
                viewIncomes = this.buildIncomes();
            }
        }

        return (
            <div>
                <label>{formatText('contentStepsTitles-accountUse')}</label>
                <RadioButton
                    profileModel={profileModel}
                    optionsList={optionsList}
                    isRequired
                    isUpdated={() => {
                        const modelName = model[1];
                        let operations;
                        const name = userProfile[modelName];
                        const purpose = {
                            personal: false,
                            other: false,
                            professional: false,
                        };
                        purpose[name] = true;
                        if (name !== 'personal') {
                            operations = generatedOperations();
                        } else {
                            const operationsData = this.generatedOperationsData();
                            const incomesData = getIncomesData();
                            operations = generatedOperations(false);

                            formActions.resetValidity(`${profileModel}_list`);
                            formActions.resetValidity('userProfile.is_income');

                            operationsData.forEach(option => {
                                formActions.resetValidity(option.model);
                            });

                            incomesData.forEach(option => {
                                formActions.resetValidity(option.model);
                            });
                        }

                        if (resetIncomes && (hasPEP === 'false' || typeof hasPEP === 'undefined') && name !== 'other') {
                            // Reset incomes
                            formActions.change('userProfile.income_work', false);
                            formActions.change('userProfile.income_activities', false);
                            formActions.change('userProfile.income_business', false);
                            formActions.change('userProfile.income_realState', false);
                            formActions.change('userProfile.income_description', null);
                            formActions.resetValidity('userProfile.income_description');
                            formActions.change('userProfile.income_other', false);
                        }

                        handleSave('purpose', purpose);
                        handleSave('operations', operations);
                    }}
                    focusAnimated
                    {...this.props}
                />

                {viewOperation}
                {viewIncomes}
            </div>
        );
    }
}

accountUse.defaultProps = {
    resetIncomes: true,
};

module.exports.constructor = accountUse;
module.exports.accountUse = connect(
    state => ({
        focus: state.focus,
    }),
    null
)(accountUse);
